import { useEffect } from 'react';
import { useUIStore } from '../store';

export const NetworkStatus = () => {
  const { isOnline, setOnlineStatus } = useUIStore();

  useEffect(() => {
    const handleOnline = () => setOnlineStatus(true);
    const handleOffline = () => setOnlineStatus(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Set initial status
    setOnlineStatus(navigator.onLine);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [setOnlineStatus]);

  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 bg-red-600 text-white text-center py-2 text-sm z-50">
      <div className="flex items-center justify-center space-x-2">
        <span>📶</span>
        <span>No internet connection. Some features may not work properly.</span>
      </div>
    </div>
  );
};